import {
  useState,
  useImperativeHandle,
  useRef,
  useEffect,
  forwardRef,
  useCallback,
} from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import {
  selectCollections,
  selectReferenceCollectionsData,
} from "../../pages/DataModels";
import { EMPTY_ARRAY, EMPTY_STRING } from "../../constants";
import { checkBlackIcon } from "../../assets/icons";

const DropdownEditor = (field) =>
  forwardRef(function DropdownEditor(props, ref) {
    const { value, name } = props;

    const { data: collections } = useSelector(selectCollections);
    const referenceCollectionsData = useSelector(
      selectReferenceCollectionsData
    );

    const [selected, setSelected] = useState(
      value ?? field.schema.defaultValue
    );
    const [options, setOptions] = useState(EMPTY_ARRAY);
    const refInput = useRef(null);

    useEffect(() => {
      const referenceTableId = get(
        field,
        ["schema", "referenceTableId"],
        EMPTY_STRING
      );
      const referenceColumn = get(
        field,
        ["schema", "referenceTableColumn"],
        EMPTY_STRING
      );
      const referencedCollection = referenceCollectionsData.find(
        ({ id }) => id === referenceTableId
      );
      if (referencedCollection) {
        const referencedCollectionKeys = Array.from(
          new Set(
            referencedCollection.data.map(
              (data) => data[referenceColumn || "id"]
            )
          )
        );
        const updatedReferencedCollectionKeys = referencedCollectionKeys.filter(
          (value) => value
        );
        setOptions(updatedReferencedCollectionKeys);
      } else setOptions(field.meta.options);
    }, [referenceCollectionsData, collections]);

    // afterGuiAttached
    useEffect(() => refInput.current.focus(), []);

    useImperativeHandle(ref, () => {
      return {
        // the final value to send to the grid, on completion of editing
        getValue() {
          return selected;
        },
      };
    });

    const onChangeListener = useCallback(
      (event) => setSelected(event.target.value),
      []
    );

    return (
      <div className="w-full h-full bg-white flex items-center pr-2 py-1">
        <select
          defaultValue={EMPTY_STRING}
          name={name}
          value={selected}
          onChange={onChangeListener}
          className="w-full h-full pl-4 text-sm text-black border-none focus:ring-transparent rounded-2xl bg-indigo-200 mx-2 py-0 cursor-pointer"
          ref={refInput}
        >
          <option disabled value={EMPTY_STRING} className="bg-white">
            Select Record
          </option>
          {options.map((option) => {
            const value = option instanceof Object ? option.value : option;
            const key = option instanceof Object ? option.id : option;
            return (
              <option key={key} value={value} className="bg-white">
                {value}
              </option>
            );
          })}
        </select>
        <img
          src={checkBlackIcon}
          alt="check-icon"
          className="w-4 h-4 cursor-pointer"
          onClick={() => props.api.stopEditing()}
        />
      </div>
    );
  });
export default DropdownEditor;
